import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPayoneerComponent } from './simple-icons-payoneer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPayoneerComponent ],
    exports:      [ SimpleIconsPayoneerComponent ],
    bootstrap:    []
})
export class SimpleIconsPayoneerModule {}
